import * as React from 'react'
import { useLocale, useRecording } from '../../providers'
import { useStatefulRef, useAudio } from '../../hooks'
import { IconButton } from '../Buttons'
import { RecorderIntroWrapper } from './styles'

const { useState, useEffect } = React

interface RecorderIntroProps {
  proceed: () => void
  /* */
}

export const RecorderIntro: React.FC<RecorderIntroProps> = ({ proceed }) => {
  const [autoPlayAttempted, setAutoPlayAttempted] = useState(false)
  const [audioRef, setAudioRef] = useStatefulRef<HTMLAudioElement>(null)
  const audioRefNonNull = audioRef as React.RefObject<HTMLAudioElement>
  const { getText, getTranslation } = useLocale()
  const { play, state } = useAudio({ ref: audioRefNonNull })
  const { isPlaying } = state
  const { recordingSettings } = useRecording()
  const { introText, introAudio } = recordingSettings
  // @ts-ignore
  const audioSrc = introAudio?.asset?.url as string
  const skipLabel = getText('skipIntroLabel')

  const introTextTranslation = introText ? getTranslation(introText) : undefined

  useEffect(() => {
    try {
      play()
    } catch { }
    setAutoPlayAttempted(true)
  }, [audioSrc])

  const showListenLabel = isPlaying !== true && autoPlayAttempted === true

  return (
    <RecorderIntroWrapper>
      <div>
        {introAudio ? (
          <div hidden>
            <audio ref={setAudioRef} controls={false} src={audioSrc} />
          </div>
        ) : null}

        <IconButton
          icon="microphone"
          label={showListenLabel ? getText('introListenLabel') : '\u00A0'}
          onClick={play}
          spinning={isPlaying}
        />
      </div>
      {introTextTranslation ? <p>{introTextTranslation}</p> : null}

      <button onClick={proceed} >
        {skipLabel} →
      </button>
    </RecorderIntroWrapper>
  )
}
